import {
  AudioFile,
  RenameRequest,
} from '@weave/schema-gen-ts/dist/schemas/phone/audio-library/v1/audio_library_service.pb';
import {
  AudioLibraryUsage,
  CallRouteUsage,
  OverrideUsage,
  PrimitiveUsage,
} from '@weave/schema-gen-ts/dist/schemas/phone/audio-library/v1/audio_library_service.pb';
import { SchemaAudioLibraryService, SchemaIO } from '@frontend/schema';

export type ListAudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.List>;
export type RenameAudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.Rename>;
export type DeleteAudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.Delete>;
export type UsageAudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.Usage>;
export type UsageV2AudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.UsageV2>;
export type TTSLanguagesAudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.TTSLanguages>;
export type TTSVoicesAudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.TTSVoices>;
export type RingtonesAudioLibraryTypes = SchemaIO<typeof SchemaAudioLibraryService.Ringtones>;
export type AudioFileType = AudioFile & {
  downloadUrl?: string;
};
export type RenameRequestType = RenameRequest;

export const isOverrideUsage = (
  usage: AudioLibraryUsage
): usage is AudioLibraryUsage & { overrideUsage: OverrideUsage } => {
  return 'overrideUsage' in usage;
};

export const isPrimitiveUsage = (
  usage: AudioLibraryUsage
): usage is AudioLibraryUsage & { primitiveUsage: PrimitiveUsage } => {
  return 'primitiveUsage' in usage;
};

export const isCallRouteUsage = (
  usage: AudioLibraryUsage
): usage is AudioLibraryUsage & { callRouteUsage: CallRouteUsage } => {
  return 'callRouteUsage' in usage;
};

export enum PrimitiveUsageType {
  IVR_MENU = 'IVR_MENU',
  CALL_QUEUE = 'CALL_QUEUE',
  HOLD_MUSIC = 'HOLD_MUSIC',
}

export const getUsageDetails = (usage: AudioLibraryUsage): { name: string; id: string; usageCount?: number } => {
  if (isOverrideUsage(usage)) {
    return {
      name: usage.overrideUsage.name,
      id: usage.overrideUsage.overrideId,
    };
  }
  if (isCallRouteUsage(usage)) {
    return {
      name: usage.callRouteUsage.callRouteName,
      id: usage.callRouteUsage.callRouteId,
      usageCount: usage.callRouteUsage.usageCount,
    };
  }
  if (isPrimitiveUsage(usage)) {
    return {
      name: usage.primitiveUsage.name,
      id: usage.primitiveUsage.primitiveId,
    };
  }
  return { name: 'Unknown Usage', id: '' };
};
